import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.OptimisticLockingPopup', {
    title: 'Newer request version has been published',
    description: `
        Either refresh the page and start editing the latest request version or publish an outdated 
        request version with your changes and overwrite others' edits.`,
    buttonOverwrite: 'Overwrite',
    buttonCancel: 'Continue editing',
});
